module.exports = __webpack_public_path__ + "static/media/socialPiper-budget-desktop-es.d62aeec4.png";